import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSignaturePlans } from 'vendor/hooks/useSignaturePlans';
import SignaturePlanList from './SignaturePlanList';

// Loads the Signature Collection plans and shows them. Used by the setup wizard's plan step for
// signature vendors, in place of the standard plan picker.
const SignaturePlanChooser = ({ onChoose, isBusy = false }) => {
    const { t } = useTranslation();
    const { plans, isLoading, error } = useSignaturePlans();

    if (error) {
        return <p className="error-text">{t('SignaturePlans.LoadError')}</p>;
    }
    if (isLoading) {
        return null;
    }
    return <SignaturePlanList plans={plans} onChoose={onChoose} isBusy={isBusy} />;
};

export default SignaturePlanChooser;
